import React, { useRef, useEffect, useState } from "react";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// core components
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import IndexHeader from "../../components/Headers/IndexHeader";
import DemoFooter from "../../components/Footers/DemoFooter";
import Gallery from "../../components/Carousel";
import ImageGallery from "react-image-gallery";
import { Link } from "react-router-dom";
import { Hidden } from "@material-ui/core";

//third party carousel
// import Slider from "react-slick";

const LandingPage = () => {
  const [colHeight, setColHeight] = useState(500);
  const [merajText, setMerajText] = useState(false);
  const [merajGateImage, setMerajGateImage] = useState(false);
  document.documentElement.classList.remove("nav-open");
 

 
  const useStyles = makeStyles((theme) => ({
    comingSoonSectionMobile: {
      [theme.breakpoints.down("xs")]: {
        minHeight: 193,
      },
    },
    comingSoonTextMobile: {
      [theme.breakpoints.down("xs")]: {
        fontSize: 20,
      },
    },
    iconMobile: {
      height: 60,
      [theme.breakpoints.down("xs")]: {
        height: "30px",
      },
    },
    AMENITIESMobile: {
      [theme.breakpoints.down("xs")]: {
        padding: 11,
      },
    },
    footerLogoMobile: {
      [theme.breakpoints.down("xs")]: {
        height: 130,
      },
    },
    plotCardMobile: {
      [theme.breakpoints.down("xs")]: {
        maxHeight: 275,
        minHeight: 275,
      },
    },
  }));
  const classes = useStyles();

  
  

  const formRef = useRef(null);

  const merajTextRef = useRef();
  const merajEntranceGate = useRef();

  const isInViewport = (offset = 0) => {
    if (!merajTextRef) return false;
    const top = merajTextRef.current.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset <= window.innerHeight;
  };

  

  return (
    <>
      <ExamplesNavbar formRef={formRef} />
      <IndexHeader />
    
      <div className="main" style={{backgroundColor:"#3e3c3d"}}>
        
        
        <div className="location-importance-section full-screen content-center" style={{backgroundColor:"#3e3c3d"}}>
          <Container>
            <Row noGutters={true}>
              
              <Col className="col-12">
                <div id="get-height" className="content-center">
                  <div>
                    <h3 className="title text-white text-uppercase">
                      Live at the heart of the districts <hr></hr>
                    </h3>
                    <br />
                    <div>
                    Sialkot’s first society located at the most ideal location of the district. 
                    Located just 250 feet away from the newly laid motorway.
                     Meraj housing aims to provide our city with a modern state of the art 
                     society with world-class amenities at the most prime location of the 
                     district, Sialkot <br />
                     
                      <br />
                      Our society will surely standout from the rest because of 
                      its Modern lifestyle, convenience in travelling and unparalleled 
                      facilities in a green and serene atmosphere for our residents to enjoy. <br />
                      <br />
                      We understand the need for a modern society in the city hence our infrastructure is
                      inspired by the modern minimalist trend highlighting sleek and clean exteriors executed 
                      by a team of renowned designers and architects. Our society will surely have a huge
                      impact in adding value to the dignity of our city. <br />
                    </div>
                  </div>
                </div>
              </Col>
              
            </Row>
          </Container>
        </div>



        <div className="park-featur-container" style={{backgroundColor:"#3e3c3d", color:"#ffffff"}}>
          <Container>
            <Row noGutters={true}>
              <Col className="col-6" lg={6}>
                <div
                  style={{ position: "relative" }}
                  className="left-border h-100"
                >
                  
                </div>
              </Col>
              <Col lg={12}>
                <img
                  className="park-parking-image"
                  src={require("assets/img/newimglanding/Frame5.jpg")}
                ></img>
              </Col>
            
            
            </Row>

          </Container>
        </div>



      <div className="location-section" style={{backgroundColor:"#3e3c3d"}}>
          <Container >
            <Row noGutters={true}>
              <Col lg={12} >
                <div className="importance" style={{backgroundColor:"#3e3c3d"}}>
                  {/* <h3 className="title text-center heading">Importance of location</h3> */}
                  
                  <div className="important-points">
                    <div className="text-uppercase">
                      <h3>Importance of location</h3>
                      The most centrally connected society:<hr></hr> <br /> <br />
                    </div>
                    <ul>
                      <li>
                      Located just 250 feet away from the newly laid motorway. 
                      The geographical location of the society makes it the most
                      ideal place to live. The society is well connected to all 
                      nearby premium locations in the shortest time possible adding 
                      convenience to the life of residents
                      <hr width="0" height="100" color="white"></hr>
                      </li>
                      <br />
                      <li>
                      Travelling avoiding the crowded city highways is a great stress reliever in 
                      today’s time. The prime location will be highly favorable for the residents 
                      for hassle free travelling through motorway m11, which will give easy access 
                      to all nearby cities, landmarks and attractions. 
                      </li>
                      <br />
                      <li>
                      Our prime location will provide the best connectivity hence improving the lifestyle of our residentss.
                      <br></br>
                      <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                      </li>
                      
                    </ul>
                    
                  </div>
                </div>
              </Col>


              <Col lg={12} >
                <div className="importance-paper" >
                  <div className="paper " style={{backgroundColor:"#3e3c3d"}} >
                    <h6
                      style={{
                        textTransform: "uppercase",
                        color:"#ffffff"
                      }}
                      className="title"
                    >
                      <font color="#ffffff">
                      Travel Time to Premium Locations<br/>
                      from MERAJ HOUSING through MOTORWAY M11
                      </font>
                      </h6>
                    <table className="table text-white">
                      <tbody>
                        <tr>
                          <th>Destinations</th>
                          <th>Distance</th>
                          <th>Time</th>
                        </tr>
                        <tr>
                          <td>
                            <img
                              className="map-marker-white"
                              src={require("assets/resources/map-pin.svg")}
                            />
                            Daska
                          </td>
                          <td>3 km</td>
                          <td>5 mins</td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              className="map-marker-black"
                              src={require("assets/resources/map-pin.svg")}
                            />
                            Sambrial{" "}
                          </td>
                          <td>13 km</td>
                          <td>12 mins</td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              className="map-marker-white"
                              src={require("assets/resources/map-pin.svg")}
                            />
                            Sialkot
                          </td>
                          <td>16 km</td>
                          <td>17 mins</td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              className="map-marker-black"
                              src={require("assets/resources/map-pin.svg")}
                            />
                            Ugoki
                          </td>
                          <td>18 km</td>
                          <td>19 mins</td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              className="map-marker-white"
                              src={require("assets/resources/map-pin.svg")}
                            />
                            Sialkot Airport
                          </td>
                          <td>22 km</td>
                          <td>20 mins</td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              className="map-marker-black"
                              src={require("assets/resources/map-pin.svg")}
                            />
                            Lahore
                          </td>
                          <td>100 km</td>
                          <td>41 mins</td>
                        </tr>
                      </tbody>
                    </table>
                   
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          </div>
                     


         <div className="park-featur-container" style={{backgroundColor:"#3e3c3d", color:"#ffffff"}}>
          <Container>
          <Row noGutters={true}>
              <Col className="col-6" lg={6}>
                <div
                  style={{ position: "relative" }}
                  className="left-border h-100"
                >
                  
                </div>
              </Col>
              <Col lg={12}>
                <img
                  className="park-parking-image"
                  src={require("assets/img/newimglanding/Frame9.jpg")}
                ></img>
              </Col>
            
            
            </Row>




          <Row noGutters={true}>
              <Col lg={12} >
                <div className="importance" style={{backgroundColor:"#3e3c3d"}}>
                  {/* <h3 className="title text-center heading">Importance of location</h3> */}
                  
                  <div className="important-points">
                    <div className="text-uppercase">
                     <h6> Introducing City's First </h6> <br /> 
                      <h5>World Class Retail Park</h5>
                      <hr></hr>
                    </div>
                    <p>
                      Bringing world-class retail park to the city<br/>
                      of daska. The retail park will give a boom
                      to the business sector of the city and will also be an amazing
                      recreational spot for families
                      <br></br>
                      <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                    </p>
                    
                  </div>
                  
                </div>
              </Col>


         </Row>
            <Row>
              <Col className="col-6" lg={6}>
                <div
                  style={{ position: "relative" }}
                  className="left-border h-100"
                >
                  
                </div>
              </Col>
              <Col lg={12}>
                <img
                  className="park-parking-image"
                  src={require("assets/img/newimglanding/Frame10.jpg")}
                ></img>
              </Col>
            
            
            </Row>

          </Container>
          </div>



        

        

        <div className="">
          <div
            style={{
              backgroundColor:"#3e3c3d"
            }}
            className="bg-image"
          >
            <div className="payment-section" style={{ marginTop: -35 }}>
              <h4 className="title text-white">Types of Plots</h4>
              <h3 className="title text-white">3 YEARS EASY PAYMENT PLAN</h3>
              <Container fluid>
                <Row>
                  <Col className="col-lg-3 col-md-6 col-6">
                    <div
                      style={{ background: "#c4c4c4" }}
                      className={`plot-card py-5 ${classes.plotCardMobile}`}
                    >
                      <img
                        className="plot-image"
                        src={require("assets/img/plots/5.png")}
                      />
                      <h4 className="title mt-4">5 MARLA</h4>
                      <div className="mb-5">RESIDENTIAL PLOTS</div>
                      <div className="learn-more content-center" style={{ background: "#000000" }}>
                        <Link className="text-white" to="/payments">
                          LEARN MORE
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col className="col-lg-3 col-md-6 col-6">
                    <div
                      style={{ background: "#c4c4c4" }}
                      className={`plot-card py-5 ${classes.plotCardMobile}`}
                    >
                      <img
                        className="plot-image"
                        src={require("assets/img/plots/10.png")}
                      />
                      <h4 className="title mt-4">10 MARLA</h4>
                      <div className="mb-5">RESIDENTIAL PLOTS</div>
                      <div className="learn-more content-center" style={{ background: "#000000" }}>
                        <Link className="text-white" to="/payments">
                          LEARN MORE
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col className="col-lg-3 col-md-6 col-6">
                    <div
                      style={{ background: "#c4c4c4" }}
                      className={`plot-card py-5 ${classes.plotCardMobile}`}
                    >
                      <img
                        className="plot-image"
                        src={require("assets/img/plots/1.png")}
                      />
                      <h4 className="title mt-4">1 KANAL</h4>
                      <div className="mb-5">RESIDENTIAL PLOTS</div>
                      <div className="learn-more content-center" style={{ background: "#000000" }}>
                        <Link className="text-white" to="/payments">
                          LEARN MORE
                        </Link>
                      </div>
                    </div>
                  </Col>
                  <Col className="col-lg-3 col-md-6 col-6">
                    <div
                      style={{ background: "#c4c4c4" }}
                      className={`plot-card py-5 ${classes.plotCardMobile}`}
                    >
                      <img
                        className="plot-image"
                        src={require("assets/img/plots/commercial.png")}
                      />
                      <h4 className="title mt-4">COMMERCIAL PLOTS</h4>
                      <div className="learn-more content-center" style={{ background: "#000000" }}>
                        <Link className="text-white" to="/payments">
                          LEARN MORE
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>

        <div
          className={`footer-logo-section content-center ${classes.footerLogoMobile}`}
          style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image" 
            src={require("assets/img/logo@2x.png")}
          />
        </div>
      </div>
      <DemoFooter />
    </>
  );
};

export default LandingPage;
